/**
 * Dónde está cada casilla del cuerpo de la Solicitud de Posicionamiento, en pt sobre
 * la hoja, con el origen arriba a la izquierda.
 *
 * ⚠ **Es la ÚNICA fuente de estas coordenadas, y la leen dos dibujantes.** La hoja de
 * la pantalla (`SolicitudPosicionamiento.tsx`) pinta los campos donde se escribe; el
 * generador del PDF (`pdf.ts`) pone el texto encima de la página original del SENIAT.
 * Si cada uno llevara sus números, al primer ajuste de una casilla la pantalla y el
 * papel dejarían de coincidir — y el papel es lo que se entrega y lo que queda en el
 * registro.
 *
 * La cabecera y el pie son comunes a los dos formatos y viven en `medidas.ts`.
 */

export type Caja = {
  readonly x: number
  readonly y: number
  readonly w: number
  readonly h: number
}

export const POSICIONAMIENTO = {
  dua: { x: 59.5, y: 129.3, w: 89.5, h: 20.1 },
  bl: { x: 156.5, y: 129.3, w: 134.6, h: 20.1 },
  agencia: { x: 297.8, y: 129.3, w: 145.2, h: 20.1 },
  registro: { x: 450.4, y: 128.5, w: 107.4, h: 21 },
  reconocimiento: {
    dia: { x: 59.5, y: 172.4, w: 51.4, h: 17.9 },
    mes: { x: 117, y: 172.4, w: 49.2, h: 17.9 },
    anio: { x: 172.2, y: 171.4, w: 73.8, h: 18.9 },
  },
  funcionario: { x: 251.6, y: 169.2, w: 149.7, h: 21 },
  color: { x: 410.1, y: 169.2, w: 147.6, h: 21 },
  almacen: { x: 59.5, y: 203.7, w: 128.6, h: 20.7 },
  codigo: { x: 197.6, y: 203.7, w: 128.6, h: 20.7 },
  mercancia: { x: 336.1, y: 204.5, w: 221.7, h: 19.9 },
  contenedor: { x: 245.9, y: 241.4, w: 15.9, h: 12.5 },
  cargaSuelta: { x: 245.9, y: 259.6, w: 15.9, h: 10.8 },
  cantidad: { x: 319.6, y: 247.6, w: 28.6, h: 17.4 },
  /** Tres renglones: el formato no tiene más, y su nota dice qué hacer con el cuarto. */
  siglas: [
    { x: 367, y: 241.4, w: 182.9, h: 17.6 },
    { x: 366.2, y: 263.1, w: 184.4, h: 20 },
    { x: 366.3, y: 286.1, w: 184.4, h: 21.1 },
  ],
} as const satisfies Record<string, Caja | Record<string, Caja> | readonly Caja[]>
